import React from 'react'
import DocumentTitle from 'react-document-title'

import Select from '../components/Select'
import PhotoPreview from '../components/PhotoPreview'
import Lightbox from '../components/Lightbox'
import PageHero from "../components/PageHero"
import PageHeroContentSection from "../components/PageHeroContentSection"
import { getPageTitle } from "../utility/utility"

import './Neighborhood.scss'
import backgroundTransit from '../images/background/transportation-bg.jpg'
import backgroundCultural from '../images/background/cultural-bg.jpg'
import backgroundRestaurants from '../images/background/restaurant-bg.jpg'

import preview1 from '../images/neighborhood/preview/photo-1.jpg'
import preview2 from '../images/neighborhood/preview/photo-5.png'
import preview3 from '../images/neighborhood/preview/general-green.jpg'
import preview4 from '../images/neighborhood/preview/barclays-center.jpg'
import preview5 from '../images/neighborhood/preview/habana-outpost.jpg'
import preview6 from '../images/neighborhood/preview/greenlight-bookstore.jpg'
import preview7 from '../images/neighborhood/preview/brooklyn-academy-of-music.jpg'
import preview8 from '../images/neighborhood/preview/ft-green-steps.jpg'
import preview9 from '../images/neighborhood/preview/baba-cool-cafe.jpg'
import preview10 from '../images/neighborhood/preview/hungry-ghost.jpg'
import preview11 from '../images/neighborhood/preview/habana-works.jpg'
import preview12 from '../images/neighborhood/preview/greene-grape.jpg'
import preview13 from '../images/neighborhood/preview/citibike.jpg'
import preview14 from '../images/neighborhood/preview/scoops-sweets.jpg'
import preview15 from '../images/neighborhood/preview/lirr.jpg'
import preview16 from '../images/neighborhood/preview/annex.jpg'
import preview17 from '../images/neighborhood/preview/gnarly-vines.jpg'
import preview18 from '../images/neighborhood/preview/cello-player.jpg'

import full1 from '../images/neighborhood/full/photo-1.jpg'
import full2 from '../images/neighborhood/full/photo-5.jpg'
import full3 from '../images/neighborhood/full/general-green.jpg'
import full4 from '../images/neighborhood/full/barclays-center.jpg'
import full5 from '../images/neighborhood/full/habana-outpost.jpg'
import full6 from '../images/neighborhood/full/greenlight-bookstore.jpg'
import full7 from '../images/neighborhood/full/brooklyn-academy-of-music.jpg'
import full8 from '../images/neighborhood/full/ft-green-steps.jpg'
import full9 from '../images/neighborhood/full/baba-cool-cafe.jpg'
import full10 from '../images/neighborhood/full/hungry-ghost.jpg'
import full11 from '../images/neighborhood/full/habana-works.jpg'
import full12 from '../images/neighborhood/full/greene-grape.jpg'
import full13 from '../images/neighborhood/full/citibike.jpg'
import full14 from '../images/neighborhood/full/scoops-sweets.jpg'
import full15 from '../images/neighborhood/full/lirr.jpg'
import full16 from '../images/neighborhood/full/annex.jpg'
import full17 from '../images/neighborhood/full/gnarly-vines.jpg'
import full18 from '../images/neighborhood/full/cello-player.jpg'


const BACKGROUNDS = {
  transit: backgroundTransit,
  cultural: backgroundCultural,
  restaurants: backgroundRestaurants
}

const PHOTOS = [{
  preview: preview1,
  full: full1,
  caption: ''
}, {
  preview: preview2,
  full: full2,
  caption: ''
}, {
  preview: preview3,
  full: full3,
  caption: ''
}, {
  preview: preview4,
  full: full4,
  caption: ''
}, {
  preview: preview5,
  full: full5,
  caption: ''
}, {
  preview: preview6,
  full: full6,
  caption: ''
}, {
  preview: preview7,
  full: full7,
  caption: ''
}, {
  preview: preview8,
  full: full8,
  caption: ''
}, {
  preview: preview9,
  full: full9,
  caption: ''
}, {
  preview: preview10,
  full: full10,
  caption: ''
}, {
  preview: preview11,
  full: full11,
  caption: ''
}, {
  preview: preview12,
  full: full12,
  caption: ''
}, {
  preview: preview13,
  full: full13,
  caption: ''
}, {
  preview: preview14,
  full: full14,
  caption: ''
}, {
  preview: preview15,
  full: full15,
  caption: ''
}, {
  preview: preview16,
  full: full16,
  caption: ''
}, {
  preview: preview17,
  full: full17,
  caption: ''
}, {
  preview: preview18,
  full: full18,
  caption: ''
}];

export default class NeighborhoodPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 'transit',
      initialLightboxSlide: -1
    };
  }

  static pageTitle() {
    return 'Fort Greene Luxury Apartments Near BAM | 300 Ashland Pl';
  }

  renderPhotoPreview(index) {
    return (
      <PhotoPreview
        photo={PHOTOS[index]}
        className={`photo-preview-${index + 1} collage__item`}
        onClick={() => this.setState({ initialLightboxSlide: index })}
        onKeyPress={() => this.setState({ initialLightboxSlide: index })}
      />
    );
  }

  render() {
    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className='content' id="main" role="main">
          <PageHero heading="The Neighborhood">
            <PageHeroContentSection>
              <p>
                Fort Greene is a vibrant community with incredible history and beauty.
                The 30-acre, Olmstead designed, Fort Greene Park boasts running paths
                with rolling hills, tennis and basketball courts, playgrounds and
                open areas to barbeque or let dogs run. The tree-lined streets feature
                well-preserved 19th-century architecture, stately brownstones, and
                destination-worthy food, drinks, shopping, and iconic institutions.
                BAM Cinemas, Barclays Center, and the Mark Morris Dance Center offer
                a vast array of cultural events and entertainment right at your doorstep.
              </p>
            </PageHeroContentSection>
          </PageHero>


          <div className='collage'>
            <div className='row'>
              <div className='column small'>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(0)}
                </div>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(1)}
                </div>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(2)}
                </div>
              </div>
              <div className='column large'>
                <div className='row'>
                  {this.renderPhotoPreview(3)}
                </div>
                <div className='row'>
                  {this.renderPhotoPreview(4)}
                  {this.renderPhotoPreview(5)}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='column large'>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(6)}
                </div>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(7)}
                </div>
              </div>
              <div className='column small'>
                <div className='row'>
                  {this.renderPhotoPreview(8)}
                </div>
                <div className='row'>
                  {this.renderPhotoPreview(9)}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='column med'>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(10)}
                </div>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(11)}
                </div>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(12)}
                </div>
                <div className='row flex-end'>
                  {this.renderPhotoPreview(17)}
                </div>
              </div>
              <div className='column med'>
                <div className='row'>
                  {this.renderPhotoPreview(13)}
                </div>
                <div className='row'>
                  {this.renderPhotoPreview(14)}
                </div>
                <div className='row'>
                  {this.renderPhotoPreview(15)}
                </div>
                <div className='row'>
                  {this.renderPhotoPreview(16)}
                </div>
              </div>
            </div>
          </div>

          <div tabIndex="0" aria-label="map of area. For accessible version please contact 300 Ashland" className='map-section'>
            <div className='background-image map-bg'>
              <img alt={this.state.selected} src={BACKGROUNDS[this.state.selected]} className='background filler' />
              <div className={this.state.selected}>
                <div className='transit-icons icon-box'>
                  <div className='map-icon t-2345'></div>
                  <div className='map-icon lirr'></div>
                  <div className='map-icon c'></div>
                  <div className='map-icon g'></div>
                  <div className='map-icon bq'></div>
                </div>
                <div className='cultural-icons icon-box'>
                  <div className='map-icon t-2345'></div>
                  <div className='map-icon lirr'></div>
                  <div className='map-icon c'></div>
                  <div className='map-icon g'></div>
                  <div className='map-icon bq'></div>
                </div>
                <div className='restaurants-icons icon-box'>
                  <div className='map-icon t-2345'></div>
                  <div className='map-icon lirr'></div>
                  <div className='map-icon c'></div>
                  <div className='map-icon g'></div>
                  <div className='map-icon bq'></div>
                </div>
              </div>
            </div>
            <div className='menu'>
              <h2>In the middle of:</h2>
              <Select
                options={[{
                  id: 'transit',
                  label: 'Trains to anywhere in the city'
                }, {
                  id: 'cultural',
                  label: 'Brooklyn\'s cultural scene'
                }, {
                  id: 'restaurants',
                  label: 'Eating, drinking, shopping, and relaxing'
                }]}
                onSelect={option => this.setState({
                  selected: option.id
                })}
              />

              <div className='image-box'></div>
            </div>
          </div>

          <Lightbox
            slides={PHOTOS.map(it => ({img: {src: it.full, caption: it.caption}}))}
            startSlide={this.state.initialLightboxSlide}
            onClose={() => this.setState({ initialLightboxSlide: -1 })}
          />
        </div>
      </DocumentTitle>
    )
  }

}



// WEBPACK FOOTER //
// ./client/pages/Neighborhood.js